/**
 * Main container
 * imported in App.js
 */
import React, {Component} from "react";
import {Route, Routes} from "react-router-dom";
// import SignInWrapper from "../views/login/signin/signIn-wrapper";
import AuthenticatedWrapper from "../AuthenticatedWrapper";
// import {google} from "../services/login/properties";
import LoginComponent from "../views/login/signin/LoginComponent";
import RouteWrapper from "../routing/RouterWrapper";

class Main extends Component {
    // constructor(props) {
    //     super(props);
    //     this.getSignIn = this.getSignIn.bind(this);
    // }

    render() {
        return (
            <Routes>
                <Route path='/login' element={<LoginComponent />} />
                <Route
  path="/*"
  element={<RouteWrapper component={AuthenticatedWrapper} />}
/>
            </Routes>

        );
    }

    // getSignIn() {
    //     return <SignInWrapper asyncScriptOnLoad={onLoad}/>
    // }
}


// function onLoad() {
//     window.gapi && window.gapi.load('auth2', function () {
//         window.auth2 = window.gapi.auth2.init({
//             client_id: google.auth.client_id,
//             redirect_uri: google.auth.redirect_uri
//         });
//     });
// }


export default Main;
